import { supabase } from "../lib/supabase";
import { APP_HOME } from "../lib/appRoutes";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * @param {{
 *   fireAt: Date,
 *   title: string,
 *   body?: string,
 *   url?: string,
 *   audience: "all_with_push" | "all_users",
 * }} params
 */
export async function fetchAdminNudgesOverview() {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/nudges`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}

export async function scheduleAdminNudges({
  fireAt,
  title,
  body,
  url,
  audience,
}) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/nudges`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      fireAt: fireAt.toISOString(),
      title,
      body: body || null,
      url: url || APP_HOME,
      audience,
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Planung fehlgeschlagen (${res.status}).`);
  }
  return data;
}
